export default {"id":"0735a964","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}